<template>
  <div class="endCustomers">
    <EntityList
      v-bind:endpoint="`api/end_customers`"
      v-bind:filters="`?page=1&customer.id=${id}`"
      v-bind:entity="endCustomerEntity"
      v-bind:editAllowedFields="['email', 'password']"
      v-bind:notShowEditAction="false"
      v-bind:notShowDeleteAction="false"
      v-bind:addLinkToDetails="false"
      v-bind:notDisplayedFields="['timestamp', 'password']"
      v-bind:defaultValues="{}"
      v-bind:enableSearch="true"
      v-bind:searchFields="[{ text: 'Email', value: 'email' }, { text: 'Account ID', value: 'foAccountId' }, { text: 'Customer Name', value: 'name' }]"/>
  </div>
</template>

<script>
import EntityList from '../EntityList/EntityList.vue';
import EndCustomerEntity from '../../store/entity/EndCustomer';

export default {
  name: 'CustomerDetailsEndCustomer',
  components: { EntityList },
  data() {
    return {
      endCustomerEntity: EndCustomerEntity,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    loadCustomerName() {
      this.$http.get(`/api/customers/${this.id}`).then((response) => {
        this.$store.commit('setCustomPageTitle', `End Customers for ${response.data.name}`);
      });
    },
  },
  mounted() {
    this.$store.state.showCdLinks = true;
  },
  created() {
    this.loadCustomerName();
  },
  destroyed() {
    this.$store.state.showCdLinks = false;
    this.$store.commit('clearCustomPageTitle');
  },
};
</script>

<style scoped>

</style>
